import styled from 'styled-components';

const SlideUpComponentStyles = styled.div`
  background: #fff;
  box-shadow: 0 -10px 20px rgba(0, 0, 0, 0.2);
  height: 0;
  left: 0;
  position: fixed;
  opacity: 0;
  overflow: auto;
  pointer-events: none;
  top: 100%;
  transition: top 0.25s cubic-bezier(0.57, 0.06, 0, 1.06);
  width: 100%;
  z-index: 3;

  &.active {
    min-height: 100vh;
    opacity: 1;
    pointer-events: auto;
    top: 0;

  }

  .children-wrapper {
    padding: 3.5rem 0 6rem;
    text-align: center;

    ${props => props.theme.media.md} {
      padding-top: 60px;
    }

    .back-btn {
      background: transparent;
      border: none;
      font-size: 1rem;
      height: 1.5rem;
      line-height: 1;
      margin: 0;
      padding: 0;
      position: absolute;
      left: 20px;
      top: 60px;
      width: 1.5rem;
      z-index: 3;

      ${props => props.theme.media.lg} {
        left: 50px;
        top: 70px;
      }
    }

    .close-btn {
      background: transparent;
      border: none;
      font-size: 1rem;
      height: 1.5rem;
      line-height: 1;
      margin: 0;
      padding: 0;
      position: absolute;
      right: 20px;
      top: 60px;
      width: 1.5rem;
      z-index: 3;

      ${props => props.theme.media.lg} {
        right: 50px;
        top: 70px;
      }
    }
  }
`;

export default SlideUpComponentStyles;
